import { ShareholderToGetAllByPersonId } from 'model/shareholder.model';
import { api } from 'services/api/api';

const apiUrl = '/api/shareholders';

const shareholderApi = () => {
    const getAllBypersonId = (personId: string) => api.get<ReadonlyArray<ShareholderToGetAllByPersonId>>(`${apiUrl}/${personId}`);

    return {
        getAllBypersonId
    };
};

export default shareholderApi();
